export const sendToNewRelic = (
  attributeName: string,
  attributeValue: any,
  windowObject: Record<string, any>,
) => {
  const { newrelic } = windowObject;

  if (newrelic) {
    newrelic.setCustomAttribute(attributeName, attributeValue);
  }
};
